<template>
  <div class="content-page row">
    <div class="left-wrap medium-12">
      <subaccount-header
        :search-query="searchQuery"
        :on-search-submit="onSearchSubmit"
        :on-input-search="onInputSearch"
        header-title="SUBACCOUNTS.HEADER"
      />

      <subaccount-table
        :subaccounts="subaccounts"        
        :empty-message="emptyMessage"
        :is-loading="uiFlags.isFetching"
        @on-sort-change="onSortChange"
      />

      <table-footer
        :current-page="Number(meta.current_page)"
        :total-count="meta.count"
        :page-size="15"
        @page-change="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SubaccountHeader from './SubaccountHeader';
import SubaccountTable from './SubaccountTable';
import TableFooter from 'dashboard/components/widgets/TableFooter';

import alertMixin from 'shared/mixins/alertMixin';

const DEFAULT_PAGE = 1;

export default {
  components: {    
    SubaccountHeader,    
    SubaccountTable,
    TableFooter,
  },
  mixins: [alertMixin],
  data() {
    return {      
      searchQuery: '',
      sortConfig: null,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'subaccounts/getUIFlags',
      meta: 'subaccounts/getMeta',
      subaccounts: 'subaccounts/getSubaccounts',
    }),    
    emptyMessage() {
      if (this.showEmptySearchResult) {
        return this.$t('SUBACCOUNTS.LIST.NO_SUBACCOUNTS');
      }
      return this.$t('SUBACCOUNTS.LIST.404');
    },
    showEmptySearchResult() {
      const hasEmptyResults = !!this.searchQuery && this.subaccounts.length === 0;
      return hasEmptyResults;
    },
    pageParameter() {
      const selectedPageNumber = Number(this.$route.query?.page);

      return !Number.isNaN(selectedPageNumber) &&
        selectedPageNumber >= DEFAULT_PAGE
        ? selectedPageNumber
        : DEFAULT_PAGE;
    }    
  },
  mounted() {
    this.fetch(this.pageParameter);
  },
  methods: {
    updatePageParam(page) {
      window.history.pushState({}, null, `${this.$route.path}?page=${page}`);
    },
    async fetch(page) {
      this.updatePageParam(page);
      let value = '';

      if (this.searchQuery.charAt(0) === '+') {
        value = this.searchQuery.substring(1);
      } else {
        value = this.searchQuery;
      }

      const requestParams = {
        page,
        sort: this.getSortAttribute(),
      };

      if (!value) {
        this.$store.dispatch('subaccounts/get', {...requestParams, page_index: true});
      } else {        
        this.$store.dispatch('subaccounts/search', {
          search: encodeURIComponent(value),
          ...requestParams,
        });
      }
    },
    getSortAttribute() {
      if(!this.sortConfig || Object.keys(this.sortConfig).length == 0){
        return null;
      }
      let sortAttr = Object.keys(this.sortConfig).reduce((acc, sortKey) => {
        const sortOrder = this.sortConfig[sortKey];
        if (sortOrder) {
          const sortOrderSign = sortOrder === 'asc' ? '' : '-';
          return `${sortOrderSign}${sortKey}`;
        }
        return acc;
      }, '');      
      return sortAttr;
    },
    onPageChange(page) {      
      this.fetch(page);
    },
    onInputSearch(event) {
      const newQuery = event.target.value;
      const refetchAll = !!this.searchQuery && newQuery === '';
      this.searchQuery = newQuery;
      if (refetchAll) {
        this.fetch(DEFAULT_PAGE);
      }
    },
    onSearchSubmit() {      
      if (this.searchQuery) {
        this.fetch(DEFAULT_PAGE);
      }
    },
    onSortChange(params) {
      this.sortConfig = params;
      this.fetch(this.meta.current_page);
    }    
  },
};
</script>

<style lang="scss" scoped>
.content-page {
  width: 100%;
}

.left-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>

